import { observer } from 'mobx-react-lite';
import { sendFeedback as sendFeedback_1 } from 'owa-locstrings/lib/strings/sendfeedback.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda */
import * as React from 'react';
import SendFeedbackContainer from '../util/SendFeedbackContainer';

import { ControlIcons } from 'owa-addins-icons';
import { IconButton } from '@fluentui/react/lib/Button';
import { Modal } from '@fluentui/react/lib/Modal';

let styles = require('./InClientStorePanel.scss');

interface InClientStorePanelProps {
    storeUrl: string;
}

export interface InClientStorePanelHandle {
    setPanelOpen(): void;
}

export default observer(
    function InClientStorePanel(
        props: InClientStorePanelProps,
        ref: React.Ref<InClientStorePanelHandle>
    ) {
        const [isPanelOpen, setIsPanelOpen] = React.useState<boolean>(true);
        React.useImperativeHandle(
            ref,
            () => ({
                setPanelOpen() {
                    setIsPanelOpen(true);
                },
            }),
            []
        );
        {
            return (
                <Modal isOpen={isPanelOpen} onDismiss={() => setIsPanelOpen(false)}>
                    <div className={styles.container}>
                        <IconButton
                            className={styles.closeButton}
                            onClick={() => {
                                setIsPanelOpen(false);
                            }}
                            iconProps={{ iconName: ControlIcons.Cancel }}
                        />
                        <iframe
                            src={props.storeUrl}
                            title=""
                            className={styles.inClientStoreIFrameCenter}
                            frameBorder={0}
                        />
                    </div>
                    <div className={styles.FeedbackCommandBarCenter}>
                        <div onClick={openSendFeedbackCompose}>{loc(sendFeedback_1)}</div>
                    </div>
                </Modal>
            );
        }
    },
    { forwardRef: true }
);

function openSendFeedbackCompose() {
    SendFeedbackContainer.sendFeedback();
}
